export const DRAWER_TITLE_ID = "shift-detail-drawer-title";
